<template>
  <div class="header">
    <div class="title-wrapper">
      <span class="display-2">Share with people</span>
      <md-button class="close-btn md-icon-button md-dense" @click="onClose">
        <base-icon icon-name="close" />
      </md-button>
    </div>
    <span class="body-2">Only invited people will be able to view this experiment.</span>
  </div>
</template>

<script>
  export default {
    name: 'ShareModalHeader',
    methods: {
      onClose() {
        this.$emit('close');
      }
    }
  };
</script>

<style lang="scss" scoped>
  .header {
    margin-bottom: 34px;
  }
  .title-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 22px;
  }
  .close-btn {
    padding: 0;
    margin: 0;
    color: $color-grey;
  }
</style>
